/**
 * This is your client vue app entrypoint
 * Its loaded because it is referenced in the vite
 * entrypoint file (index.html located at the root of this project)
 *
 * External css/js files will be loaded as dependencies.
 * You may want to check the vite configuration.
 * Some plugins will register virtual components or lazyload other for us.
 *
 * @see /index.html
 * @see /vite.config.d.ts
 * @see /app.ts
 * @see /plugins/*.ts
 */

import { createApp } from './app'

/**
 * We create our app and mount it when it is ready
 *
 * @see /@/app.ts for more detailed information
 */
async function bootstrap() {
  // Start MSW in development mode to intercept API requests with mock data
  if (import.meta.env.DEV) {
    const { worker } = await import('./mocks/browser')
    await worker.start({
      onUnhandledRequest: 'bypass',
    })
  }

  const { app, router } = await createApp()
  await router.isReady()
  app.mount('#app')
}

bootstrap()
